<template lang="html">
    <div class="container container-small">
        <div class="mt-sm-3" v-if="!loading">
            <div>
                <div class="panels">
                    <div class="form-group panel">
                        <label for="newAccountEmail">{{ $t('label_email') }}</label><br/>
                        {{user.email}}
                    </div>
                    <div class="panel form-group">
                        <template v-if="!showEditPassword">
                            <label for="newAccountPassword">{{ $t('label_password') }}</label>
                            <div>*********</div>
                        </template>
                        <a class="link d-block" v-if="!user.social_account" @click="togglePasswordEdit()">{{ $t('btn_edit_password') }}</a>
                        <template v-if="showEditPassword">
                            <div class="form-group">
                                <label for="newAccountPassword">{{ $t('label_password') }}</label>
                                <span class="invalid-feedback">
                                    {{errorMsgs.password}}
                                </span>
                                <input type="password" class="form-control" v-model="password" v-bind:class="{'has-error' : errorMsgs.password}">
                            </div>
                            <div class="form-group">
                                <label for="newAccountPasswordConfirmation">{{ $t('label_confirm_password') }}</label>
                                 <span class="invalid-feedback">
                                    {{errorMsgs.passwordVerify}}
                                </span>
                                <input type="password" class="form-control" v-model="passwordVerify" v-bind:class="{'has-error' : errorMsgs.passwordVerify}">
                            </div>
                            <div class="action-button">
                                <button type="submit" class="main-btn" :class="{'disabled': saveBtnDisabled}" :disabled="saveBtnDisabled" v-on:click="validate()">{{ $t('btn_edit') }}</button>
                            </div>
                        </template>
                    </div>
                    <div class="panel form-group">
                        <template v-if="!showEditPhone">
                            <label for="newAccountPhone">{{ $t('label_phone') }}</label>
                            <div v-if="user.phone">{{user.phone}}</div>
                        </template>
                        <a class="link d-block" v-if="!user.social_account" @click="togglePhoneEdit()">{{ $t('btn_edit_phone') }}</a>
                        <template v-if="showEditPhone">
                            <div class="row align-items-end">
                                <div class="col-md col-12 pb-3 pb-md-0">
                                    <div class="form-group">
                                        <label for="newAccountPassword">{{ $t('label_phone') }}</label>
                                        <span class="invalid-feedback">
                                            {{errorMsgs.phone}}
                                        </span>
                                        <input type="tel" class="form-control" v-model="phone" @input="isNumber" v-bind:class="{'has-error' : errorMsgs.phone}">
                                    </div>
                                </div>
                                <div class="col-md col-12">
                                    <div class="action-button">
                                        <button type="submit" class="main-btn" :class="{'disabled': saveBtnDisabled}" :disabled="saveBtnDisabled" v-on:click="validate()">{{ $t('btn_save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <template v-if="showSuccessMsg">
                <br>
                <div class="pb-3">
                    <div class="alert alert-success text-center">
                        {{ $t('data_saved_succesfully') }}!
                    </div>
                </div>
            </template>
            <div class="pt-4 d-flex d-md-block justify-content-between pb-3">
                <span class="custom-link pointer d-block d-md-none" @click.prevent="doLogout()"> Logout</span>
                <div class="text-right">
                    <span class="text-danger pointer" @click.prevent="deleteAccount()"><i class="fa fa-trash"></i> {{ $t('btn_delete_account') }}</span>
                </div>
                <div class="alert text-center" v-bind:class="{'alert-success': deleteRequestDoesntExist, 'alert-danger': !deleteRequestDoesntExist}" v-if="deleteAccountRequest">
                    <template v-if="!deleteRequestDoesntExist">
                        {{$t('delete_request_already_sent_message')}}
                    </template>
                    <template v-if="deleteRequestDoesntExist">
                        {{$t('delete_request_sent_message')}}
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Billing',
    props: {
    },
    computed: {
        ...mapState('user', ['user']),

        saveBtnDisabled() {
            return !this.showEditPhone && !this.showEditPassword;
        }
    },
    mounted() {
        this.init();
    },
    data: function() {
        return {
            password: null,
            passwordVerify: null,
            phone: null,
            loading: true,
            errorMsgs: {
                password: '',
                passwordVerify: '',
                phone: ''
            },
            showSuccessMsg: false,
            showEditPassword: false,
            showEditPhone: false,
            deleteAccountRequest: false,
            deleteRequestDoesntExist: false
        }
    },
    methods: {

        ...mapActions({
            refreshUser: 'user/refreshUser',
            updateUser: 'user/updateUser',
            logout: 'auth/doLogout',
            actionDeleteAccount: 'user/deleteAccount'
        }),

        togglePasswordEdit() {
            this.showEditPhone = false;
            this.showEditPassword = !this.showEditPassword;
        },

        togglePhoneEdit() {
            this.showEditPassword = false;
            this.showEditPhone = !this.showEditPhone;
        },

        isNumber(e){
            let reg = new RegExp(/^\d+$/, 'i');

            if (!reg.test(e.target.value)) {
                this.user.phone = e.target.value.slice(0, -1);
                return false;
            }

            return true;
        },

        async init() {

            let response = await this.refreshUser();
            this.phone = this.user.phone;
            this.loading = false;
            this.showSuccessMsg = false;
        },

        async validate() {
            var ok = true;

            if(this.showEditPassword && this.password != this.passwordVerify) {
                ok = false;
                this.errorMsgs.passwordVerify = "Parolele nu coincid";
            }
            else {
                this.errorMsgs.passwordVerify = '';
            }

            if(this.showEditPhone && !this.phone.match(/^(\d{10})$/)) {
                ok = false;
                this.errorMsgs.phone = "Telefonul nu este valid";
            }
            else {
                this.errorMsgs.phone = '';
            }

            if(!ok) {
                return false;
            }

            try {
                let update = {};
                if(this.showEditPhone && this.phone) {
                    update['phone'] = this.phone;
                }

                if(this.showEditPassword && this.password && this.passwordVerify) {
                    update['password'] = this.password;
                    update['password_confirmation'] = this.passwordVerify;
                }

                await this.updateUser(update);
            }
            catch(error) {
                this.$dialog.alert({
                    'message': error.response.data.error.error_msg,
                    'confirmButtonText': 'Am înțeles'
                });
                ok = false;
            }

            if (ok) {
                this.showSuccessMsg = true;
                setTimeout(() => {
                    this.showSuccessMsg = false;
                }, 3000);
            }
        },

        doLogout() {
            this.logout();
            this.$router.push({ name: 'login' });
        },

        deleteAccount(id) {

            this.$dialog.confirm({
                title: 'Stergere cont',
                message: 'Esti sigur ca vrei sa stergi contul?',
                cancelButtonText: this.$t('no'),
                confirmButtonText: this.$t('yes'),
                beforeClose: this.doDeleteAccount
            })
            .then(response => {
            })
            .catch(() => {
                // on cancel
            });
        },

        doDeleteAccount(action, done) {
            if(action == 'confirm') {
                this.actionDeleteAccount().then(async response => {
                    this.deleteAccountRequest = true;
                    this.deleteRequestDoesntExist = response.data.success;

                    await this.init();
                    done();
                }).catch(err => {
                    if(err.response) {
                        this.$dialog.alert({
                            'message': err.response.data.error.error_msg,
                            'confirmButtonText': this.$t('btn_i_understand')
                        });
                    }
                    done();
                });
            }
            else {
                done();
            }
        }
    }
};
</script>

<style lang="scss" scoped>


p {
    margin-bottom: 0;
    margin-top: 15px;
}

.link {
    @media only screen and (min-width: 769px) {
        right: 25px;
        position: absolute;
        top: 10px;
    }
}

.panels {
    background: #FFFEFD;

    @media only screen and (max-width: 768px) {
        margin: 0px -18px;
    }

    .panel {
        border-bottom: 1px solid #C7C7C6;
        padding: 15px 20px;
        position: relative;
    }
}

.action-button {
    .main-btn {
        @media only screen and (min-width: 769px) {
            max-width: 160px;
        }
    }
}

</style>
